export default {
      id: "i-download-button-usage",
      viewBox: "0 0 21 20",
      url: __webpack_public_path__ + "img/sprite.svg#i-download-button",
      toString: function () {
        return this.url;
      }
    }